import React, { useState, useEffect } from "react";
import { SESClient, SendEmailCommand } from "@aws-sdk/client-ses";
import Header from "../../components/header/Header";
import { API, graphqlOperation } from "aws-amplify";
import { createPrivateScreening } from "../../graphql/mutations";
import { listPrivateScreenings, listCompanyProfiles, listCandidateProfiles, listInterviewSlots } from "../../graphql/queries";
import {
  updateCompanyProfile,
  deletePrivateScreening,
} from "../../graphql/mutations";
import { useNavigate, useLocation } from "react-router-dom";


//animation premium
// import { useSpring, animated } from "react-spring";

const SendMail = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [privateScreenings, setPrivateScreenings] = useState([]);
  const [deletPrivateScreenings, setDeletPrivateScreenings] = useState([]);
  const location = useLocation();
  const { jobId } = location.state || {};
  
  // Debug jobId only once when component mounts
  useEffect(() => {
    if (jobId) {
      console.log("SendMail: jobId received from navigation:", jobId);
    } else {
      console.log("SendMail: No jobId provided, showing all private screenings");
    }
  }, []); // Empty dependency array ensures this runs only once

  // company state

  const [companyList, setCompanyList] = useState([]);
  const [nextToken, setNextToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingScreenings, setLoadingScreenings] = useState(true);
  const [company, setCompany] = useState({});
  const [companyemail, setCompanyemail] = useState("");
  const [point, setPoint] = useState(0);
  const [reming, setReming] = useState({
    remainingCredit: point,
  });
  const [companyID, setCompanyID] = useState("");

  // premium show

  const [showModels, setShowModels] = useState(false);

  const [profiles, setProfiles] = useState([]);
  const navigate = useNavigate();
  const [userFullName, setUserFullName] = useState();
  const [hasCompletedProfile, setHasCompletedProfile] = useState(false);
  const [fullName, setFullName] = useState("");
  const [photoURL, setPhotoURL] = useState("");
  const [workStatus, setWorkStatus] = useState("");
  const [description, setDescription] = useState("");
  const [keySkills, setKeySkills] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [githubURL, setGithubURL] = useState("");
  const [linkedinURL, LinkedinURL] = useState("");
  const [wait, setWait] = useState(false);
  const [waitingEmail, setWaitingEmail] = useState(null);
  // const storedCompanyID = localStorage.getItem("CompanyProfileID");
  const storedCompanyID = localStorage.getItem("CompanyProfileID") || 
                         localStorage.getItem("candidateProfileEmailID") ||
                         localStorage.getItem("companyProfileID");
  const requiredEmail = "hr@varahitechnologies.com";

  // useEffect(() => {

  //   const fetchData = async () => {
  //     try {
  //       const candidateProfileEmailID = localStorage.getItem('candidateProfileEmailID');
  //       setCompanyemail(candidateProfileEmailID);
  //       console.log("Email id from send mail", candidateProfileEmailID)

  //       if (!candidateProfileEmailID) {
  //         // Handle case where candidate email is not found
  //         return;
  //       }

  //       const { data } = await API.graphql(
  //         graphqlOperation(listCompanyProfiles, {
  //           filter: {
  //             email: { eq: candidateProfileEmailID },
  //           },
  //           limit: 100, // Limit the number of items per page, adjust as needed
  //           nextToken: nextToken // Pass nextToken if available
  //         })
  //       );
  //       console.log("data from send mail", data)
  //       setCompany(data.listCompanyProfiles.items[0])
  //       setPoint(company.remainingCredit)
  //       console.log("direct data from ", data.listCompanyProfiles.items[0])
  //       console.log("*************from send mail company from*************", company)

  //       if (data && data.listCompanyProfiles.items) {
  //         const { items, nextToken } = data.listCompanyProfiles;
  //         setCompanyList(prevList => [...prevList, ...items]); // Merge new items with existing list
  //         setNextToken(nextToken); // Set the nextToken for pagination
  //         setLoading(false); // Set loading to false after data is fetched
  //       }
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //       // Handle error
  //     }
  //   };

  //   fetchData();

  // }, [nextToken])

  useEffect(() => {
    // Check for different possible localStorage keys for company data
    const storedCompanyEmail = localStorage.getItem("CompanyEmailID") || 
                               localStorage.getItem("companyEmail") ||
                               localStorage.getItem("email");
    const storedCompanyID = localStorage.getItem("CompanyProfileID") || 
                           localStorage.getItem("companyProfileID") ||
                           localStorage.getItem("companyId");

    // Also check if we have candidate data in localStorage that might contain company info
    const candidateData = localStorage.getItem("publicInterviewCandidateData");
    const slotData = localStorage.getItem("publicInterviewSlotData");
    
    console.log("SendMail localStorage check:", {
      storedCompanyEmail,
      storedCompanyID,
      candidateData: candidateData ? "present" : "missing",
      slotData: slotData ? "present" : "missing",
      allKeys: Object.keys(localStorage)
    });

    // Set initial values from localStorage
    if (storedCompanyEmail) setCompany(storedCompanyEmail);
    if (storedCompanyID) setCompanyID(storedCompanyID);

    const fetchData = async () => {
      if (!loading) return; // Only fetch if still loading
      
      try {
        const candidateProfileEmailID = localStorage.getItem("candidateProfileEmailID") ||
                                      localStorage.getItem("CompanyEmailID") ||
                                      localStorage.getItem("email");
        
        console.log("Attempting to fetch company data with email:", candidateProfileEmailID);
        
        if (!candidateProfileEmailID) {
          console.log("No email found in localStorage for company data fetch");
          setLoading(false);
          return;
        }

        setCompanyemail(candidateProfileEmailID);

        const { data } = await API.graphql(
          graphqlOperation(listCompanyProfiles, {
            filter: {
              email: { eq: candidateProfileEmailID },
            },
            limit: 100,
          })
        );

        if (
          data &&
          data.listCompanyProfiles.items &&
          data.listCompanyProfiles.items.length > 0
        ) {
          const companyData = data.listCompanyProfiles.items[0];
          console.log("Company data fetched successfully:", companyData);
          setCompany(companyData);
          setPoint(companyData.remainingCredit);
          
          const { items } = data.listCompanyProfiles;
          setCompanyList(items); // Set directly instead of appending
        } else {
          console.log("No company data found for email:", candidateProfileEmailID);
        }
      } catch (error) {
        console.error("Error fetching company data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array - only run on mount

  // console.log("*********company**********", company); // Remove repetitive console logs
  // console.log("*********company**********", company);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Create an SES client
      const sesClient = new SESClient({
        region: "ap-south-1",
        credentials: {
          // accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
          // secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY
        },
      });
      console.log(`email`, email);
      // Define the email parameters
      const emailParams = {
        Source: "getscreened@varahitechnologies.com",
        Destination: {
          ToAddresses: [email], // Update with the verified email address
        },
        Message: {
          Subject: {
            Data: `Congratulations! You've Been Selected for ${company.companyName}`,
          },
          Body: {
            Text: {
              Data: `Dear ${name},

              Greetings of the Day!
              I am delighted to inform you that you have been selected for further consideration at our Company ${company.companyName}. Your application has impressed us, and we believe your skills and experience are a great fit for our team.
              As the next step in our hiring process, we would like to invite you for a private screening interview for the position of ${message}. To streamline the process, we have set up an online portal for the interview. You can access the interview portal using the following link: https://www.getscreened.in. We have also provided a YouTube video for your reference: https://www.youtube.com/watch?si=r94pgS7GIIy-p6j-&v=3rMe3qx9Amc&feature=youtu.be.
              Please select a suitable time slot from the available options in the portal. If none of the provided times work for you, please let us know, and we will do our best to accommodate your schedule.
              During the interview, we will discuss the role of ${message} in more detail, delve into your qualifications, and explore how your expertise aligns with our company's goals and values.
              After the interview, if you have any questions or require further information, please feel free to reach out to us. Additionally, once the interview is completed, our team will follow up with you to provide feedback and discuss the next steps in the hiring process.
              Congratulations once again on being selected! We look forward to meeting with you and exploring the possibility of you joining our team.
              Best regards,
              ${company.contactPersonName}
              ${company.contactPersonDesignation}
              ${company.contactPersonEmail}
              ${company.contactPersonNumber}
              ${company.email}`,
            },
          },
        },
      };

      // Send the email using the SendEmailCommand
      const sendEmailCommand = new SendEmailCommand(emailParams);
      await sesClient.send(sendEmailCommand);

      console.log("Email sent successfully");

      // Reset the form after successful submission
      setName("");
      setEmail("");
      setMessage("");

      // updating the point

      const updateCompanyPoint = async () => {
        try {
          // Declare variables
          let candidateProfileEmailID, data, companyData, items, newNextToken;

          // Fetch candidate profile email ID from local storage
          candidateProfileEmailID = localStorage.getItem(
            "candidateProfileEmailID"
          );
          setCompanyemail(candidateProfileEmailID);

          // Check if candidate email is available
          if (!candidateProfileEmailID) {
            // Handle case where candidate email is not found
            return;
          }

          // setPoint(point-30)

          let currentRemainingCredit = point;
          let updatedRemainingCredit = currentRemainingCredit - 30;

          setPoint(updatedRemainingCredit);

          const updateInput = {
            id: company.id, // Assuming you have the company ID available
            remainingCredit: updatedRemainingCredit,
          };

          // Fetch company profiles data
          const result = await API.graphql(
            graphqlOperation(updateCompanyProfile, {
              input: updateInput,
            })
          );

          console.log(
            "Remaining credit updated successfully:",
            updatedRemainingCredit
          );

          console.log(
            "*************point after deduct*****************",
            point
          );
          console.log(
            "*************point after deduct*****************",
            reming
          );
          // Destructure data from result
          data = result.data;

          // Check if data is available
          if (
            data &&
            data.listCompanyProfiles.items &&
            data.listCompanyProfiles.items.length > 0
          ) {
            // Extract company data
            companyData = data.listCompanyProfiles.items[0];
            setCompany(companyData);
            // DON'T overwrite the credit - we already set it correctly above
            // setPoint(companyData.remainingCredit); // REMOVED - this was causing the fluctuation!

            console.log("SendMail: Credit successfully updated to:", updatedRemainingCredit);

            // Save company email and ID to local storage

            // Note: company and companyID won't have the updated values immediately after setCompany/setCompanyID

            // Extract items and newNextToken
            items = data.listCompanyProfiles.items;
            newNextToken = data.listCompanyProfiles.nextToken;

            // Update company list and next token
            setCompanyList((prevList) => [...prevList, ...items]);
            setNextToken(newNextToken);
            setLoading(false);
          } else {
            setLoading(false); // Set loading to false if no data is found
          }
        } catch (error) {
          console.error("Error fetching data:", error);
          // Handle error
          setLoading(false); // Set loading to false on error
        }
      };

      updateCompanyPoint();
    } catch (error) {
      console.error("Error sending email:", error);
    }
  };

  // Function to create a new PrivateScreening object
  const createPrivateScreeningInvitation = async () => {
    const privatescreeningDetails = {
      companyProfileID: companyID,
      jobDescription: message,
      invitedCandidates: [{ email: email, name: name }],
      // Add any other required fields
    };

    try {
      const response = await API.graphql(
        graphqlOperation(createPrivateScreening, {
          input: privatescreeningDetails,
        })
      );
      console.log(
        "Private screening created:",
        response.data.createPrivateScreening
      );
      // Handle the successful response as needed
    } catch (error) {
      console.error("Error creating private screening:", error);
      // Handle the error as needed
    }
  };

  // Function to fetch PrivateScreening data and filter by companyProfileID
  const fetchPrivateScreenings = async (companyProfileID, jobId) => {
    if (!companyProfileID) {
      console.warn("No companyProfileID provided, skipping fetch");
      setLoadingScreenings(false);
      return;
    }
    
    setLoadingScreenings(true);
    try {
      let nextToken = null;
      const allScreenings = [];

      // Determine the filter based on presence of jobId
      const filter = jobId
        ? { jdID: { eq: jobId } }
        : { companyProfileID: { eq: companyProfileID } };

      // Fetch data with pagination
      do {
        const response = await API.graphql(
          graphqlOperation(listPrivateScreenings, {
            filter: filter,
            limit: 100, // Adjust the limit as needed
            nextToken: nextToken,
          })
        );
        const { items, nextToken: newToken } =
          response.data.listPrivateScreenings;
        allScreenings.push(...items);
        nextToken = newToken;
      } while (nextToken);

      // Update state with fetched screenings
      setPrivateScreenings(allScreenings);
      
      // Only log if there's meaningful data to show
      if (allScreenings.length > 0) {
        console.log(`Fetched ${allScreenings.length} private screenings`);
      }
    } catch (error) {
      console.error("Error fetching private screenings:", error);
    } finally {
      setLoadingScreenings(false);
    }
  };

  useEffect(() => {
    const companyProfileID = localStorage.getItem("CompanyProfileID") ||
                           localStorage.getItem("companyProfileID") ||
                           localStorage.getItem("companyId");
    
    console.log("Fetching private screenings with:", { companyProfileID, jobId });
    
    if (companyProfileID) {
      fetchPrivateScreenings(companyProfileID, jobId);
    } else {
      console.log("No companyProfileID found, cannot fetch private screenings");
      // If no company profile ID, set empty array and stop loading
      setPrivateScreenings([]);
      setLoadingScreenings(false);
    }
  }, [jobId]); // Remove deletPrivateScreenings dependency to prevent unnecessary re-renders

  const handleDeletePrivateCandidate = async (
    id,
    candidateName,
    candidateEmail
  ) => {
    // Confirm deletion with user, showing candidate's name and email
    const confirmDelete = window.confirm(
      `Are you sure you want to delete the private screening for ${candidateName} (${candidateEmail})?`
    );

    if (!confirmDelete) {
      return; // If user cancels deletion, exit function
    }

    try {
      const input = { id };
      await API.graphql(graphqlOperation(deletePrivateScreening, { input }));

      // Update state after deletion
      const updatedScreenings = privateScreenings.filter(
        (screening) => screening.id !== id
      );
      setPrivateScreenings(updatedScreenings);

      console.log(`Successfully deleted private screening with ID: ${id}`);
    } catch (error) {
      console.error("Error deleting private screening:", error);
    }
  };

  // premium show function

  const handlePremiumClick = () => {
    setShowModels(true);
  };

  // const getEmail = async (email) =>{
  //   console.log("/////////////////////getemail////////////////////",email)

  //   let nextToken = null;
  //   let userProfileList = [];
  //   do {
  //     const userProfileResponse = await API.graphql(
  //       graphqlOperation(listCandidateProfiles, {
  //         filter: { email: { eq: email } },
  //         limit: 100,
  //         nextToken: nextToken,
  //       })
  //     );
  //     console.log("=============================",userProfileResponse)

  //     userProfileList.push(
  //       ...userProfileResponse.data.listCandidateProfiles.items
  //     );
  //     nextToken = userProfileResponse.data.listCandidateProfiles.nextToken;
  //   } while (nextToken);

  //   // Set user profile details
  //   if (userProfileList.length > 0) {
  //     setUserFullName(userProfileList[0].fullName);
  //     // setHasCompletedProfile(userProfileList[0].fullName.trim() !== "");
  //   } else {
  //     console.log("User profile not found.");
  //     // setHasCompletedProfile(false);
  //   }

  // }

  const getEmail = async (email) => {
    try {
      if (email) {
        console.log("/////////////////////getemail////////////////////", email);
        setWait(true);
        setWaitingEmail(email);

        let nextToken = null;
        let userProfileList = [];
        do {
          const userProfileResponse = await API.graphql(
            graphqlOperation(listCandidateProfiles, {
              filter: { email: { eq: email } },
              limit: 100,
              nextToken: nextToken,
            })
          );
          console.log("=============================", userProfileResponse);

          userProfileList.push(
            ...userProfileResponse.data.listCandidateProfiles.items
          );
          nextToken = userProfileResponse.data.listCandidateProfiles.nextToken;
        } while (nextToken);

        console.log(
          "###################################################",
          userProfileList[0]
        );
        setUserFullName(userProfileList[0]);
        console.log("#$#$#$#$#$#$#$#$#$#$#$#$#$#$#$##$#$#$#", userFullName);
        // Set user profile details

        if (userProfileList.length > 0) {
          setUserFullName(userProfileList[0]);
          setHasCompletedProfile(userProfileList[0].fullName.trim() !== "");

          // Fetch interview slots for this candidate
          let slotNextToken = null;
          let interviewSlots = [];
          do {
            const slotsResponse = await API.graphql(
              graphqlOperation(listInterviewSlots, {
                filter: { candidateEmail: { eq: email } },
                limit: 100,
                nextToken: slotNextToken,
              })
            );
            
            interviewSlots.push(
              ...slotsResponse.data.listInterviewSlots.items
            );
            slotNextToken = slotsResponse.data.listInterviewSlots.nextToken;
          } while (slotNextToken);

          console.log("Interview slots found:", interviewSlots);

          // Get the most recent completed interview slot
          const completedSlots = interviewSlots.filter(
            slot => slot.candidateAttendance === true || slot.botAttendance === true
          );

          // Sort by date (most recent first)
          const sortedSlots = completedSlots.sort((a, b) => {
            const dateA = new Date(a.date + 'T' + a.startTime);
            const dateB = new Date(b.date + 'T' + b.startTime);
            return dateB - dateA;
          });

          // Use the most recent slot, or any slot if no completed slots
          const slotToUse = sortedSlots.length > 0 ? sortedSlots[0] : 
                           (interviewSlots.length > 0 ? interviewSlots[0] : null);

          if (slotToUse) {
            // Navigate with slotId
            navigate(`/CompanyCandidateViewProfilev1/${encodeURIComponent(email)}?slotId=${slotToUse.id}`);
          } else {
            // Navigate without slotId if no slots found
            console.log("No interview slots found, navigating to profile without slotId");
            navigate(`/CompanyCandidateViewProfilev1/${encodeURIComponent(email)}`);
          }
        } else {
          console.log("User profile not found.");
          // setHasCompletedProfile(false);
          alert("Candidate Not yet Registered");
          // setWait(false)
          // setWaitingEmail(null)
        }

        setWait(false);
        setWaitingEmail(null);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      // Handle error appropriately, e.g., throw error or return empty array

      setWait(false);
      setWaitingEmail(null);
    }
  };
  const handleClick = async (email) => {
    //  await getEmail(email); // Call getEmail function with the provided email
    if (!wait) {
      getEmail(email);
    }
  };



  // console.log("***********point*************", point);
  // console.log("*******private scrning***********", privateScreenings);
  // console.log("***************company ID****************", companyID);

  // console.log("***********point*************", point);
  // console.log("*******private scrning***********", privateScreenings);
  // console.log("***************userfullname****************", userFullName.email);

  return (
    <div className="min-h-screen bg-[#030712] text-white overflow-hidden relative">
      {/* Aurora Background Effects */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-1/2 -left-1/2 w-full h-full bg-gradient-to-br from-purple-500/20 via-transparent to-transparent rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute -bottom-1/2 -right-1/2 w-full h-full bg-gradient-to-tl from-blue-500/20 via-transparent to-transparent rounded-full blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gradient-to-r from-cyan-500/10 to-transparent rounded-full blur-2xl"></div>
      </div>

      <Header />
      
      <div className="relative z-10 px-6 py-6">
        {/* Company Authentication Warning */}
        {!companyID && !companyemail && (
          <div className="bg-red-500/10 backdrop-blur-xl border border-red-500/20 rounded-xl p-4 mb-6">
            <h3 className="font-bold text-lg mb-2 text-red-400">Company Access Required</h3>
            <p className="text-red-300/80 text-sm">
              This page is for company users to manage private screening candidates. 
              It appears you are not logged in as a company user.
            </p>
            <p className="text-red-300/80 text-sm mt-2">
              Please log in with your company account to access this page.
            </p>
          </div>
        )}

        {/* Header */}
        <div className="mb-4">
          <h1 className="text-2xl font-bold bg-gradient-to-r from-purple-400 via-pink-400 to-blue-400 bg-clip-text text-transparent mb-1">
            Private Candidate List
          </h1>
          <h2 className="text-gray-400 text-xs">Manage your private screening invitations</h2>
        </div>

        {loadingScreenings ? (
          <div className="space-y-1">
            {[1, 2, 3, 4, 5].map((i) => (
              <div
                key={i}
                className="relative bg-white/5 backdrop-blur-xl rounded overflow-hidden"
              >
                <div className="px-3 py-1.5">
                  <div className="flex items-center gap-2">
                    {/* Avatar skeleton */}
                    <div className="w-8 h-8 rounded-full bg-gray-700/50 animate-pulse"></div>
                    
                    {/* Name skeleton */}
                    <div className="min-w-[150px]">
                      <div className="h-3 bg-gray-700/50 rounded animate-pulse w-3/4"></div>
                    </div>
                    
                    {/* Email skeleton */}
                    <div className="min-w-[200px]">
                      <div className="h-3 bg-gray-700/50 rounded animate-pulse w-full"></div>
                    </div>
                    
                    {/* Job description skeleton */}
                    <div className="flex-1">
                      <div className="h-3 bg-gray-700/50 rounded animate-pulse w-5/6"></div>
                    </div>
                    
                    {/* Button skeletons */}
                    <div className="flex items-center gap-1.5">
                      <div className="w-16 h-6 bg-gray-700/50 rounded animate-pulse"></div>
                      <div className="w-8 h-6 bg-gray-700/50 rounded animate-pulse"></div>
                    </div>
                  </div>
                </div>
                
                {/* Shimmer effect */}
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/5 to-transparent"></div>
              </div>
            ))}
          </div>
        ) : privateScreenings.length === 0 ? (
          <div className="flex items-center justify-center py-16">
            <div className="inline-flex flex-col items-center gap-4 px-8 py-12 bg-white/5 backdrop-blur-xl rounded-2xl border border-white/10">
              <span className="material-symbols-outlined text-6xl text-gray-500">person_search</span>
              <p className="text-xl text-gray-400">No private screening candidates found</p>
              <p className="text-sm text-gray-500 mt-1">
                Private screening invitations will appear here once they are created
              </p>
            </div>
          </div>
        ) : (
          <div className="space-y-1">
            {privateScreenings.map((data, index) => (
              <div
                key={index}
                className="group relative bg-white/5 backdrop-blur-xl rounded hover:bg-white/10 transition-all duration-300"
              >
                {/* Gradient overlay on hover */}
                <div className="absolute inset-0 bg-gradient-to-r from-purple-500/5 to-blue-500/5 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                <div className="relative z-10 px-3 py-1.5">
                  <div className="flex items-center gap-2">
                    {/* Avatar */}
                    <div className="w-8 h-8 rounded-full bg-gray-700 flex items-center justify-center text-gray-300 font-medium text-xs flex-shrink-0">
                      {data.candidateName?.charAt(0).toUpperCase() || 'C'}
                    </div>

                    {/* Candidate Name - Inline */}
                    <div className="flex items-center gap-2 text-xs text-white font-medium min-w-[150px]">
                      {data.candidateName}
                    </div>

                    {/* Email - Inline */}
                    <div className="flex items-center gap-1 text-[11px] text-gray-400 min-w-[200px] truncate">
                      <span className="material-symbols-outlined text-sm">mail</span>
                      {data.candidateEmail}
                    </div>

                    {/* Job Description - Inline */}
                    <div className="flex-1 min-w-0 flex items-center gap-1 text-[11px] text-gray-300 truncate">
                      <span className="material-symbols-outlined text-sm">description</span>
                      <span className="truncate">{data.jobDescription}</span>
                    </div>

                    {/* Actions */}
                    <div className="flex items-center gap-1.5 flex-shrink-0">
                      <button
                        onClick={() => handleClick(data.candidateEmail)}
                        disabled={waitingEmail === data.candidateEmail}
                        className="px-2.5 py-1 bg-gray-700 hover:bg-gray-600 rounded text-white text-[10px] font-medium transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1 whitespace-nowrap"
                      >
                        {waitingEmail === data.candidateEmail ? (
                          <>
                            <span className="material-symbols-outlined animate-spin text-sm">progress_activity</span>
                            Processing...
                          </>
                        ) : (
                          <>
                            <span className="material-symbols-outlined text-sm">visibility</span>
                            View
                          </>
                        )}
                      </button>

                      {storedCompanyID === requiredEmail && (
                        <button
                          onClick={() =>
                            handleDeletePrivateCandidate(
                              data.id,
                              data.candidateName,
                              data.candidateEmail
                            )
                          }
                          className="p-1 bg-red-500/10 hover:bg-red-500/20 rounded text-red-400 transition-all duration-300"
                          title="Delete"
                        >
                          <span className="material-symbols-outlined text-base">delete</span>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const ModelPopups = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4 bg-gray-700">
      <ModelPoint value={1000} delay={0} />
      <ModelPoint value={7000} delay={150} />
      <ModelPoint value={15000} delay={300} />
    </div>
  );
};

// ModelPoint component to display points with popup animation
const ModelPoint = ({ value, delay }) => {
  const [isVisible, setIsVisible] = useState(false);

  // Set visibility after a delay to trigger the animation
  setTimeout(() => setIsVisible(true), delay);

  return (
    <div
      className={`bg-gray-100 p-4 rounded-md shadow-md ${
        isVisible ? "scale-in" : "invisible"
      }`}
    >
      <h2 className="text-lg font-bold">Points: {value}</h2>
      {/* Additional styling for the model */}
    </div>
  );
};

export default SendMail;